<template>
  <BaseListHeader>
    <div class="flex -mx-4">
      <div class="flex-1 px-4">
        <span class="uppercase text-sm">business name / activity</span>
      </div>
      <div class="flex-1 px-4">
        <span class="uppercase text-sm">business address</span>
      </div>
      <div class="flex-1 px-4">
        <span class="uppercase text-sm">vat / office</span>
      </div>
      <div class="pr-2">
        <div class="w-10" />
      </div>
    </div>
  </BaseListHeader>
</template>

<script>
export default {
  name: 'ListingHeader',
};
</script>
